import * as React from 'react'
import styled from 'styled-components'
import {theme} from '../theme'

export interface IProps {
  className?: string
  label?: string | React.ReactNode
  checked: boolean
  onChange: (event?: React.ChangeEvent<HTMLInputElement>) => void
  type?: string
  value?: string
}

export const CheckboxClass = (props: IProps) => {
  return (
    <div className={props.className}>
      <Label>
        {props.label}
        <Input type={props.type || 'checkbox'} checked={props.checked} value={props.value} onChange={e => props.onChange(e)} />
        <Span />
      </Label>
    </div>
  )
}

const Label = styled.label`
  font-size: ${theme.fontSize.small};
  display: block;
  position: relative;
  padding-left: 28px;
  margin-bottom: 12px;
  cursor: default;
  user-select: none;
`

export const Span = styled.span`
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0px 0px 1px #000;
  &:after {
    content: '';
    position: absolute;
    display: none;
    left: 5px;
    top: 1px;
    width: 6px;
    height: 10px;
    border: 1px solid #000;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  &:hover {
    background-color: #fff;
  }
`

export const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: default;
  height: 0;
  width: 0;
  &:checked ~ ${Span}:after {
    display: block;
  }
  &:checked ~ ${Span} {
    background-color: #fff;
  }
`

export const Checkbox = styled(CheckboxClass)``
